if (!customElements.get('product-directory-filter')) {
  customElements.define(
    'product-directory-filter',
    class ProductDirectoryFilter extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-directory-filter]');
        this.input = this.form?.querySelector('input[type="search"]');
        this.status = this.querySelector('[data-directory-filter-status]');
        this.products = Array.from(this.querySelectorAll('[data-directory-product]'));
        this.groups = Array.from(this.querySelectorAll('[data-directory-group]'));
        this.navigationItems = Array.from(this.querySelectorAll('[data-directory-nav-item]'));
        this.counts = Array.from(this.querySelectorAll('[data-directory-count]'));

        if (!this.form || !this.input || !this.status || this.products.length === 0) return;

        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.filter();
        });
        this.input.addEventListener('input', () => this.filter());
      }

      filter() {
        const query = this.input.value.trim().toLocaleLowerCase();
        let visibleProductCount = 0;

        this.products.forEach((product) => {
          const matches = query === '' || product.dataset.searchTerms.includes(query);
          product.hidden = !matches;
          if (matches) visibleProductCount += 1;
        });

        this.groups.forEach((group) => {
          const groupProducts = Array.from(group.querySelectorAll('[data-directory-product]'));
          const visibleGroupCount = groupProducts.filter((product) => !product.hidden).length;
          group.hidden = query !== '' && visibleGroupCount === 0;
          this.counts
            .filter((count) => count.dataset.directoryCountFor === group.id)
            .forEach((count) => {
              count.textContent = `${visibleGroupCount} ${
                visibleGroupCount === 1
                  ? this.status.dataset.singularLabel
                  : this.status.dataset.pluralLabel
              }`;
            });
        });

        this.navigationItems.forEach((item) => {
          const group = this.querySelector(`#${CSS.escape(item.dataset.directoryNavItem)}`);
          item.hidden = Boolean(group?.hidden);
        });

        if (query === '') {
          this.status.hidden = true;
          this.status.textContent = '';
          return;
        }

        this.status.hidden = false;
        this.status.textContent =
          visibleProductCount === 0
            ? this.status.dataset.emptyLabel
            : `${this.status.dataset.resultsLabel} ${visibleProductCount} ${
                visibleProductCount === 1
                  ? this.status.dataset.singularLabel
                  : this.status.dataset.pluralLabel
              }`;
      }
    },
  );
}
